import { Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy, inject, DestroyRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { parseAsLocalDate } from '../../../shared/_utils/date-utils';
import { Form5471TextinfoService } from './form5471-textinfo.service';
import * as _ from 'lodash-es';
import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-form5471-textinfo',
    templateUrl: './form5471-textinfo.component.html',
    styleUrls: ['./form5471-textinfo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Form5471TextinfoComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  // Modal properties
  modalTitle = 'Form 5471- Information Return of U.S. Persons With Respect To Certain Foreign Corporations';
  minimise = false;
  modal_name: string | null = null;
  crudLoading = false;
  showFormLoader = false;

  // Data from AngularJS
  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};

  // Form data
  attribData: { [key: string]: any } = {};
  irsF5471ScheduleNAData: any[] = [];
  CatgData: any[] = [];
  line1Data: any[] = [];

  // Lookup data
  filingGroup: any[] = [];
  countries: any[] = [];
  states: any[] = [];
  currencies: any[] = [];
  PrincipalBusinessActivity: any[] = [];
  fobDetails: any[] = [];

  // Selected values
  selectedGroup: any = null;
  selectedGroup1: any = null;
  filedOnBehalf: any = null;

  // Country variables (4 sections: CFC, Custodian, Branch/Agent, Foreign Agent)
  countryVar: string = '';
  countryCust: string = '';
  countryAgent: string = '';
  countryCorporation: string = '';

  // Checkbox states
  checkBoxd: boolean = false;
  checkBoxf: boolean = false;
  checkBoxb1: boolean = false;
  checkBoxb2: boolean = false;
  checkBoxb3: boolean = false;
  checkBoxb4: boolean = false;
  checkBoxb5: boolean = false;
  checkBoxb1a: boolean = false;
  checkBoxb1b: boolean = false;
  checkBoxb1c: boolean = false;
  checkBoxb5a: boolean = false;
  checkBoxb5b: boolean = false;
  checkBoxb5c: boolean = false;
  checkShareholder: boolean = false;
  checkOfficer: boolean = false;
  checkDirector: boolean = false;

  // Radio button states
  radioBlk: string = '';
  radioUnblk: string = '';
  radiodisp: string = '';

  // Extra Schedule I fields
  boyEd: any = null;
  eoyEd: any = null;
  boyAgg: any = null;
  eoyAgg: any = null;
  totDed: any = null;

  // Flags
  tax_year_flag: boolean = false;
  loadPersonBehalf = false;
  loadingfob = false;
  private hasPersonBehalfAttr = false;
  refrence_iddisabled = false;
  checkFlag = true;

  // Zip pattern validation flags
  zip_flag_2a_pattern = false;
  zip_flag_2c_pattern = false;
  zip_flag_2d_pattern = false;

  // Validation flags (sections 2a, 2c, 2d)
  line_2a_name = false;
  line_2a_country_flag = false;
  add_flag_2a = false;
  add_flag_2a_f = false;
  city_flag_2a = false;
  state_flag_2a = false;
  zip_flag_2a = false;
  line_2c_name = false;
  line_2c_country_flag = false;
  add_flag_2c = false;
  add_flag_2c_f = false;
  city_flag_2c = false;
  state_flag_2c = false;
  zip_flag_2c = false;
  line_2d_name = false;
  line_2d_country_flag = false;
  add_flag_2d = false;
  add_flag_2d_f = false;
  city_flag_2d = false;
  state_flag_2d = false;
  zip_flag_2d = false;
  batch_flag_2a = false;
  batch_flag_2c = false;
  batch_flag_2d = false;

  // Initialization flags
  private isInitialized = false;
  private isLoading = false;

  constructor(
    private form5471Service: Form5471TextinfoService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private globalServiceProvider: GlobalService,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    this.initializeFromServices();
    this.tryInit();
  }

  private initializeFromServices(): void {
    const activeScreen = this.workspaceService.workspaceFactory?.activeScreen || {};
    const activeScreenData = activeScreen?.data || {};
    const selectedRowData = activeScreenData?.selected?.rowData;
    const directRowData = activeScreenData?.rowData;
    const fallbackRowData = activeScreenData && !activeScreenData.selected ? activeScreenData : {};

    const rowData = this.extractObject(selectedRowData || directRowData || fallbackRowData);
    if (Object.keys(rowData).length > 0) {
      this.rowData = rowData;
    }

    const filterParams = this.extractObject(
      activeScreen?.filters?.getFilterParams?.() ||
      activeScreen?.filters?.getFilterParamsFromCache?.() ||
      {}
    );
    if (Object.keys(filterParams).length > 0) {
      this.filterParams = filterParams;
    }

    const urls = this.extractObject(this.globalServiceProvider.GENERAL_CONFIG || {});
    if (Object.keys(urls).length > 0) {
      this.GENERAL_CONFIG = { ...this.GENERAL_CONFIG, ...urls };
    }

    const globalParams = this.extractObject(this.globalServiceProvider.global?.globalParams || {});
    if (Object.keys(globalParams).length > 0) {
      this.globalService = { ...globalParams };
    }

    this.USER_SETTINGS = this.appService.USER_SETTINGS || {};
  }

  private extractObject(value: any): Record<string, any> {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return {};
    }
    return value;
  }

  private tryInit() {
    if (this.isInitialized || this.isLoading) return;

    this.initializeFromServices();

    const taxYear = this.getCorrectTaxYear();
    this.tax_year_flag = taxYear === '2019';

    if (
      this.rowData &&
      Object.keys(this.rowData).length > 0 &&
      this.GENERAL_CONFIG &&
      (this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url)
    ) {
      this.isLoading = true;
      this.modal_name = 'form5471-textinfo';
      this.initLoadData();
    }
  }

  private getBaseUrl(): string {
    return this.GENERAL_CONFIG.base_url || this.GENERAL_CONFIG.api_url || '';
  }

  getCorrectTaxYear(): string {
    return (
      this.filterParams?.tax_year ||
      this.rowData.TAX_YEAR ||
      this.globalService?.tax_year ||
      ''
    );
  }

  private getCorrectScenario(): any {
    if (this.filterParams?.scenario) {
      return this.filterParams.scenario;
    }
    if (this.globalService?.checkLockedbj) {
      try {
        const checkLocked = safeJsonInput<any>(this.globalService.checkLockedbj, null, 'form5471-textinfo.parse1');
        if (Array.isArray(checkLocked) && checkLocked.length > 0 && checkLocked[0].scenario_key) {
          return checkLocked[0].scenario_key;
        }
      } catch (e) {}
    }
    return this.globalService?.scenario;
  }

  initLoadData() {
    this.showFormLoader = true;
    this.loadFilingGroup();
  }

  loadFilingGroup() {
    const params = {
      ...this.globalService,
      ...this.filterParams,
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario()
    };

    this.form5471Service
      .getFilingGroup(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1') {
            this.filingGroup = data.jsonObject || [];
            this.loadLookupData();
            this.loadFormData();
            this.loadCatgFilerData();
            this.load5471Line1Data();
          } else {
            this.showFormLoader = false;
            this.isLoading = false;
          }
        },
        (error: any) => {
          console.error('Error loading filing group:', error);
          this.showFormLoader = false;
          this.isLoading = false;
        }
      );
  }

  loadLookupData() {
    const params = {
      tax_year: this.getCorrectTaxYear(),
      jcd_key: this.globalService?.jcd_key || 250
    };

    this.form5471Service.getCountries(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((d: any) => {
      if (d.callSuccess === '1') this.countries = d.jsonObject || [];
    });
    this.form5471Service.getStates(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((d: any) => {
      if (d.callSuccess === '1') this.states = d.jsonObject || [];
    });
    this.form5471Service.getCurrencies(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((d: any) => {
      if (d.callSuccess === '1') {
        this.currencies = d.jsonObject || [];
        this.cdr.detectChanges();
      }
    });
    this.form5471Service.getPrincipalBusinessActivity(this.getBaseUrl(), this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((d: any) => {
      if (d.callSuccess === '1') {
        this.PrincipalBusinessActivity = d.jsonObject || [];
        const saved = this.attribData['5471_NA_1F'];
        if (saved && !this.selectedGroup1) {
          const pba = this.PrincipalBusinessActivity.find((x: any) => x.ACTIVITY_CODE == saved);
          if (pba) {
            this.selectedGroup1 = pba;
            this.cdr.detectChanges();
          }
        }
      }
    });
  }

  loadFormData() {
    const params = {
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key || 250,
      irs_form_no: 'F5471',
      combination_key: this.rowData.HO_COMBINATION_KEY
    };

    this.form5471Service
      .getFormData(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1') {
            this.irsF5471ScheduleNAData = data.jsonObject || [];
            this.processFormData();
            this.isInitialized = true;
            this.loadPersonOnBehalfIfNeeded();
          }
          this.showFormLoader = false;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        (error: any) => {
          console.error('Error loading form data:', error);
          this.showFormLoader = false;
          this.isLoading = false;
        }
      );
  }

  loadCatgFilerData() {
    const params = {
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key || 250,
      combination_key: this.rowData.HO_COMBINATION_KEY,
      action: 'modal'
    };

    this.form5471Service
      .getCatgFilerData(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data.callSuccess === '1') this.CatgData = data.jsonObject || [];
      });
  }

  load5471Line1Data() {
    const params = {
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key || 250,
      combination_key: this.rowData.HO_COMBINATION_KEY,
      ho_leid: this.rowData.LEID,
      ho_cdr_no: this.rowData.CDR_NO,
      ho_rpt_pd: this.rowData.REPORTING_PERIOD
    };

    this.form5471Service
      .get5471Line1Data(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data.callSuccess === '1') this.line1Data = data.jsonObject || [];
      });
  }

  loadPersonOnBehalfIfNeeded() {
    if (!this.hasPersonBehalfAttr) {
      this.loadingfob = true;
      this.cdr.detectChanges();
      return;
    }

    this.loadPersonBehalf = true;
    const personBehalf = this.attribData['5471_NA_PERSON_BEHALF'];
    const params = {
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key || 250,
      filing_group_key: this.selectedGroup?.FILING_GROUP_KEY
    };

    this.form5471Service
      .getTransId(this.getBaseUrl(), params, this.globalService, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.callSuccess === '1' && data.jsonObject?.length) {
            this.fobDetails = data.jsonObject;
            if (personBehalf) {
              const match = this.fobDetails.find((bg: any) => bg.LEGAL_ENTITY_ID == personBehalf);
              if (match) this.filedOnBehalf = match;
            }
          }
          this.loadingfob = true;
          this.cdr.detectChanges();
        },
        (error: any) => {
          this.loadingfob = true;
          this.cdr.detectChanges();
        }
      );
  }

  processFormData() {
    this.attribData = {};

    for (let i = 1; i < this.irsF5471ScheduleNAData.length; i++) {
      const item = this.irsF5471ScheduleNAData[i];
      if (!item.object_id || !item.attrib_value) continue;

      const tempString = item.object_id;
      const tempValue = item.attrib_value;
      const attribName = tempValue.split('~')[0];
      const attribValue = item.VALUE === '0' ? '' : item.VALUE;
      const updateFlag = item.OVERRIDE_FLAG;
      const line_no_new = item.line_no;

      if (item.BATCH_FLAG === 'Y' && item.line_no === '2a') this.batch_flag_2a = true;
      if (item.BATCH_FLAG === 'Y' && item.line_no === '2c') this.batch_flag_2c = true;
      if (item.BATCH_FLAG === 'Y' && item.line_no === '2d') this.batch_flag_2d = true;

      this.irsF5471ScheduleNAData[i] = {
        i: item,
        tax_year: tempString.split('~')[0],
        trans_type_key: tempString.split('~')[1],
        attrib_name: attribName,
        attrib_desc: tempValue.split('~')[3],
        line_attrib_key: tempValue.split('~')[1],
        trans_details_key: tempString.split('~')[3],
        occurrence: tempString.split('~')[4],
        VALUE: item.VALUE,
        form_key: tempString.split('~')[6],
        is_update: updateFlag,
        line_no: line_no_new
      };

      this.processAttribute(attribName, attribValue);
    }
  }

  processAttribute(attribName: string, attribValue: any) {
    const dateAttribs = ['5471_NA_CFC_BEGIN_DATE', '5471_NA_CFC_END_DATE', '5471_NA_1D'];
    if (dateAttribs.includes(attribName)) {
      this.attribData[attribName] = parseAsLocalDate(attribValue);
      return;
    }

    if (attribName === '5471_NA_CFC_US_COUNTRY' && attribValue === 'US') {
      this.countryVar = attribValue;
      this.attribData['5471_NA_CFC_US_COUNTRY'] = attribValue;
      this.attribData['5471_NA_CFC_F_COUNTRY'] = null;
      this.attribData['5471_NA_CFC_F_ADDRESS_1'] = null;
      this.attribData['5471_NA_CFC_F_ADDRESS_2'] = null;
      this.attribData['5471_NA_CFC_F_CITY'] = null;
      this.attribData['5471_NA_CFC_F_STATE'] = null;
      this.attribData['5471_NA_CFC_F_ZIPCODE'] = null;
    } else if (attribName === '5471_NA_CFC_F_COUNTRY' && attribValue && attribValue !== 'US') {
      this.countryVar = attribValue;
      this.attribData['5471_NA_CFC_F_COUNTRY'] = attribValue;
      this.attribData['5471_NA_CFC_US_COUNTRY'] = null;
      this.attribData['5471_NA_CFC_US_ADDRESS_1'] = null;
      this.attribData['5471_NA_CFC_US_ADDRESS_2'] = null;
      this.attribData['5471_NA_CFC_US_CITY'] = null;
      this.attribData['5471_NA_CFC_US_STATE'] = null;
      this.attribData['5471_NA_CFC_US_ZIPCODE'] = null;
    } else if (attribName === '5471_NA_PER_RECORDS_CUST_US_COUNTRY' && attribValue === 'US') {
      this.countryCust = attribValue;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_COUNTRY'] = attribValue;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_COUNTRY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_1'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_2'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_CITY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_STATE'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ZIP'] = null;
    } else if (attribName === '5471_NA_PER_RECORDS_CUST_F_COUNTRY' && attribValue && attribValue !== 'US') {
      this.countryCust = attribValue;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_COUNTRY'] = attribValue;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_COUNTRY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_1'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_2'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_CITY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_STATE'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ZIP'] = null;
    } else if (attribName === '5471_NA_BRANCH_US_COUNTRY' && attribValue === 'US') {
      this.countryAgent = attribValue;
      this.attribData['5471_NA_BRANCH_US_COUNTRY'] = attribValue;
      this.attribData['5471_NA_BRANCH_US_F_COUNTY'] = null;
      this.attribData['5471_NA_BRANCH_US_F_ADDR_1'] = null;
      this.attribData['5471_NA_BRANCH_US_F_ADDR_2'] = null;
      this.attribData['5471_NA_BRANCH_US_F_CITY'] = null;
      this.attribData['5471_NA_BRANCH_US_F_STATE'] = null;
      this.attribData['5471_NA_BRANCH_F_ZIP'] = null;
    } else if (attribName === '5471_NA_BRANCH_US_F_COUNTY' && attribValue && attribValue !== 'US') {
      this.countryAgent = attribValue;
      this.attribData['5471_NA_BRANCH_US_F_COUNTY'] = attribValue;
      this.attribData['5471_NA_BRANCH_US_COUNTRY'] = null;
      this.attribData['5471_NA_BRANCH_US_ADDR_LINE_1'] = null;
      this.attribData['5471_NA_BRANCH_US_ADDR_LINE_2'] = null;
      this.attribData['5471_NA_BRANCH_US_CITY'] = null;
      this.attribData['5471_NA_BRANCH_US_STATE'] = null;
      this.attribData['5471_NA_BRANCH_US_ZIP'] = null;
    } else if (attribName === '5471_NA_FOREIGN_AGENT_US_COUNTRY' && attribValue === 'US') {
      this.countryCorporation = attribValue;
      this.attribData['5471_NA_FOREIGN_AGENT_US_COUNTRY'] = attribValue;
      this.attribData['5471_NA_FOREIGN_AGENT_F_COUNTRY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ADDR_1'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ADDR_2'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_CITY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_STATE'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ZIP'] = null;
    } else if (attribName === '5471_NA_FOREIGN_AGENT_F_COUNTRY' && attribValue && attribValue !== 'US') {
      this.countryCorporation = attribValue;
      this.attribData['5471_NA_FOREIGN_AGENT_F_COUNTRY'] = attribValue;
      this.attribData['5471_NA_FOREIGN_AGENT_US_COUNTRY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ADDR_1'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ADDR_2'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_CITY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_STATE'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ZIP'] = null;
    } else if (attribName === '5471_NA_FILER_LEGAL_ENTITY_ID') {
      this.attribData[attribName] = attribValue;
      if (!this.selectedGroup) {
        const fg = this.filingGroup.find((x: any) => x.LEGAL_ENTITY_ID == attribValue);
        if (fg) this.selectedGroup = fg;
      }
    } else if (attribName === '5471_NA_PERSON_BEHALF') {
      this.attribData[attribName] = attribValue;
      this.hasPersonBehalfAttr = true;
    } else if (attribName === '5471_NA_1F') {
      this.attribData['5471_NA_1F'] = attribValue;
      if (attribValue) {
        const pba = this.PrincipalBusinessActivity.find((x: any) => x.ACTIVITY_CODE == attribValue);
        if (pba) this.selectedGroup1 = pba;
      }
    } else if (attribName === '5471_NA_D_Y' && attribValue === '1') {
      this.checkBoxd = true;
      this.attribData['5471_NA_D_Y'] = attribValue;
      this.attribData['5471_NA_D_N'] = null;
    } else if (attribName === '5471_NA_D_N' && attribValue === '0') {
      this.checkBoxd = false;
      this.attribData['5471_NA_D_N'] = attribValue;
      this.attribData['5471_NA_D_Y'] = null;
    } else if (attribName === '5471_NA_ALT_INFO_2019_40_IND_Y' && attribValue === '1') {
      this.checkBoxf = true;
    } else if (attribName === '5471_NA_ALT_INFO_2019_40_IND_N' && attribValue === '0') {
      this.checkBoxf = false;
    } else if (attribName === '5471_NA_B_1_Y' && attribValue === '1') this.checkBoxb1 = true;
    else if (attribName === '5471_NA_B_1_N' && attribValue === '0') this.checkBoxb1 = false;
    else if (attribName === '5471_NA_B_3_Y' && attribValue === '1') this.checkBoxb3 = true;
    else if (attribName === '5471_NA_B_3_N' && attribValue === '0') this.checkBoxb3 = false;
    else if (attribName === '5471_NA_B_4_Y' && attribValue === '1') this.checkBoxb4 = true;
    else if (attribName === '5471_NA_B_4_N' && attribValue === '0') this.checkBoxb4 = false;
    else if (attribName === '5471_NA_B_5_Y' && attribValue === '1') this.checkBoxb5 = true;
    else if (attribName === '5471_NA_B_5_N' && attribValue === '0') this.checkBoxb5 = false;
    else if (attribName === '5471_NA_B_1A_Y' && attribValue === '1') this.checkBoxb1a = true;
    else if (attribName === '5471_NA_B_1A_N' && attribValue === '0') this.checkBoxb1a = false;
    else if (attribName === '5471_NA_B_1B_Y' && attribValue === '1') this.checkBoxb1b = true;
    else if (attribName === '5471_NA_B_1B_N' && attribValue === '0') this.checkBoxb1b = false;
    else if (attribName === '5471_NA_B_1C_Y' && attribValue === '1') this.checkBoxb1c = true;
    else if (attribName === '5471_NA_B_1C_N' && attribValue === '0') this.checkBoxb1c = false;
    else if (attribName === '5471_NA_B_5A_Y' && attribValue === '1') this.checkBoxb5a = true;
    else if (attribName === '5471_NA_B_5A_N' && attribValue === '0') this.checkBoxb5a = false;
    else if (attribName === '5471_NA_B_5B_Y' && attribValue === '1') this.checkBoxb5b = true;
    else if (attribName === '5471_NA_B_5B_N' && attribValue === '0') this.checkBoxb5b = false;
    else if (attribName === '5471_NA_B_5C_Y' && attribValue === '1') this.checkBoxb5c = true;
    else if (attribName === '5471_NA_B_5C_N' && attribValue === '0') this.checkBoxb5c = false;
    else if (attribName === '5471_NA_FOB_SHAREHOLDER_Y' && attribValue === '1') this.checkShareholder = true;
    else if (attribName === '5471_NA_FOB_SHAREHOLDER_N' && attribValue === '0') this.checkShareholder = false;
    else if (attribName === '5471_NA_FOB_OFFICER_Y' && attribValue === '1') this.checkOfficer = true;
    else if (attribName === '5471_NA_FOB_OFFICER_N' && attribValue === '0') this.checkOfficer = false;
    else if (attribName === '5471_NA_FOB_DIRECTOR_Y' && attribValue === '1') this.checkDirector = true;
    else if (attribName === '5471_NA_FOB_DIRECTOR_N' && attribValue === '0') this.checkDirector = false;
    else if (attribName === '5471_NA_1B(1)_EIN_NUMBER' && (attribValue === undefined || attribValue === '')) {
      this.refrence_iddisabled = true;
    } else {
      this.attribData[attribName] = attribValue;
    }
  }

  // Event handlers
  onFilingGroupChange(fg: any) {
    this.selectedGroup = fg;
    if (fg?.LEGAL_ENTITY_ID) {
      this.set_override_flag(fg.LEGAL_ENTITY_ID, '5471_NA_FILER_LEGAL_ENTITY_ID');
    }
    this.cdr.detectChanges();
  }

  updated(filingId: string) {
    this.selectedGroup = this.filingGroup.find((x: any) => x.LEGAL_ENTITY_ID == filingId) || null;
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === '5471_NA_FILER_LEGAL_ENTITY_ID');
    if (found) found.is_update = found.VALUE == filingId ? 'N' : 'Y';
    this.cdr.detectChanges();
  }

  onPBAChange(pba: any) {
    this.selectedGroup1 = pba;
    if (pba?.ACTIVITY_CODE) this.set_override_flag(pba.ACTIVITY_CODE, '5471_NA_1F');
    this.cdr.detectChanges();
  }

  updated1(activityCode: string) {
    this.selectedGroup1 = this.PrincipalBusinessActivity.find((x: any) => x.ACTIVITY_CODE == activityCode) || null;
    this.cdr.detectChanges();
  }

  onPersonBehalfChange(item: any) {
    this.filedOnBehalf = item;
    if (item?.LEGAL_ENTITY_ID) this.setOverridesFlag(item.LEGAL_ENTITY_ID, '5471_NA_PERSON_BEHALF');
    this.cdr.detectChanges();
  }

  setOverridesFlag(value: any, attribName: string) {
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === attribName);
    if (found) found.is_update = 'Y';
  }

  set_override_flag(value: any, attribName: string) {
    this.setOverridesFlag(value, attribName);
  }

  changeCountryVar(countryCode: string, attribName: string) {
    this.countryVar = countryCode;
    this.setOverridesFlag(countryCode, attribName);
  }

  changeCountryAgent(countryCode: string, attribName?: string) {
    this.countryAgent = countryCode;
    const attr = attribName || (countryCode === 'US' ? '5471_NA_BRANCH_US_COUNTRY' : '5471_NA_BRANCH_US_F_COUNTY');
    this.setOverridesFlag(countryCode, attr);
    this.cdr.detectChanges();
  }

  changeCountryCorporation(countryCode: string, attribName?: string) {
    this.countryCorporation = countryCode;
    const attr = attribName || (countryCode === 'US' ? '5471_NA_FOREIGN_AGENT_US_COUNTRY' : '5471_NA_FOREIGN_AGENT_F_COUNTRY');
    this.setOverridesFlag(countryCode, attr);
    this.cdr.detectChanges();
  }

  changeCountryCust(countryCode: string, attribName?: string) {
    this.countryCust = countryCode;
    const attr = attribName || (countryCode === 'US' ? '5471_NA_PER_RECORDS_CUST_US_COUNTRY' : '5471_NA_PER_RECORDS_CUST_F_COUNTRY');
    this.setOverridesFlag(countryCode, attr);
    this.cdr.detectChanges();
  }

  change2a(attribName: string, value: any) {
    if (attribName === '5471_NA_BRANCH_US_NAME_1' && value != null && value !== '') {
      this.line_2a_name = false;
    }
    if (attribName === '5471_NA_BRANCH_US_NAME_1' && (!value || value === '')) {
      this.line_2a_name = true;
    }
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === attribName);
    if (found) found.is_update = 'Y';
    this.cdr.detectChanges();
  }

  change2c(attribName: string, value: any) {
    if (attribName === '5471_NA_FOREIGN_AGENT_NAME_1' && value != null && value !== '') {
      this.line_2c_name = false;
    }
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === attribName);
    if (found) found.is_update = 'Y';
    this.cdr.detectChanges();
  }

  change2d(attribName: string, value: any) {
    if (attribName === '5471_NA_PER_RECORDS_CUST_NAME_1' && value != null && value !== '') {
      this.line_2d_name = false;
    }
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === attribName);
    if (found) found.is_update = 'Y';
    this.cdr.detectChanges();
  }

  set_flag(value: any, _key: string) {
    if (_key === 'd') {
      this.setOverridesFlag(value, '5471_NA_D_Y');
      this.setOverridesFlag(value, '5471_NA_D_N');
    } else if (_key === 'g') {
      this.setOverridesFlag(value, '5471_NA_ALT_INFO_2019_40_CODE');
    }
    this.cdr.detectChanges();
  }

  changedPercent(value: any) {
    const pct = parseFloat(String(value || '0').replace('%', ''));
    this.checkFlag = !(pct < 0 || pct > 100 || isNaN(pct));
    this.setOverridesFlag(value, '5471_NA_C');
    this.cdr.detectChanges();
  }

  checkingForValidationForI(_value: string) {
    this.setOverridesFlag(this.checkBoxf ? '1' : '0', '5471_NA_ALT_INFO_2019_40_IND_Y');
    this.cdr.detectChanges();
  }

  uncheckedRadio(_ein: any, _reason: any, _refId: any) {
    if (_ein && _ein !== '') {
      this.attribData['5471_NA_1B(1)_EIN_MISSING_REASON'] = null;
    }
    if (_reason === 'APPLD FOR' || _reason === 'FOREIGNUS') {
      this.refrence_iddisabled = true;
    } else {
      this.refrence_iddisabled = false;
    }
    this.cdr.detectChanges();
  }

  radioClicked(_reason: any, _ein: any, _refId: any) {
    if (_reason === 'APPLD FOR' || _reason === 'FOREIGNUS') {
      this.attribData['5471_NA_1B(1)_EIN_NUMBER'] = null;
      this.refrence_iddisabled = true;
    } else {
      this.refrence_iddisabled = false;
    }
    this.cdr.detectChanges();
  }

  ref_id(refId: any, _reason: any, _ein: any) {
    this.setOverridesFlag(refId, '5471_NA_1B(2)');
    this.cdr.detectChanges();
  }

  prev_ref_id(value: any) {
    this.setOverridesFlag(value, '5471_NA_1B(3)');
    this.cdr.detectChanges();
  }

  changeCountryLaws(value: any) {
    this.setOverridesFlag(value, '5471_NA_1C');
    this.cdr.detectChanges();
  }

  changePrincipalPlace(value: any) {
    this.setOverridesFlag(value, '5471_NA_1E');
    this.cdr.detectChanges();
  }

  unchecked2a() {
    if (this.attribData['5471_NA_2A_EIN_NUMBER'] && this.attribData['5471_NA_2A_EIN_NUMBER'] !== '') {
      this.attribData['5471_NA_2A_EIN_MISSING_REASON'] = null;
    }
    this.cdr.detectChanges();
  }

  clicked2a() {
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === '5471_NA_2A_EIN_MISSING_REASON');
    if (found) found.is_update = 'Y';
    this.cdr.detectChanges();
  }

  personBnssChange() {
    this.setOverridesFlag(this.attribData['5471_NA_2D_FLAG'], '5471_NA_2D_FLAG');
    this.cdr.detectChanges();
  }

  unchecked() {
    if (this.attribData['5471_NA_2D_EIN_NUMBER'] && this.attribData['5471_NA_2D_EIN_NUMBER'] !== '') {
      this.attribData['5471_NA_2D_EIN_MISSING_REASON'] = null;
    }
    this.cdr.detectChanges();
  }

  clicked() {
    const found = this.irsF5471ScheduleNAData.find((e: any) => e.attrib_name === '5471_NA_2D_EIN_MISSING_REASON');
    if (found) found.is_update = 'Y';
    this.cdr.detectChanges();
  }

  // Stub for line 2a/2c/2d validations - template can call these
  line_2a_validations(_mode: string) {}
  line_2c_validations(_mode: string) {}
  line_2d_validations(_mode: string) {}

  saveForm() {
    if (
      (!this.attribData['5471_NA_1B(1)_EIN_NUMBER'] ||
        this.attribData['5471_NA_1B(1)_EIN_NUMBER'] === '' ||
        this.attribData['5471_NA_1B(1)_EIN_NUMBER'] == null) &&
      (!this.attribData['5471_NA_1B(1)_EIN_MISSING_REASON'] ||
        this.attribData['5471_NA_1B(1)_EIN_MISSING_REASON'] === '' ||
        this.attribData['5471_NA_1B(1)_EIN_MISSING_REASON'] == null) &&
      (!this.attribData['5471_NA_1B(2)'] ||
        this.attribData['5471_NA_1B(2)'] === '' ||
        this.attribData['5471_NA_1B(2)'] == null ||
        this.attribData['5471_NA_1B(2)'] === ' ')
    ) {
      this.gtwSnackbarService.openSnackBar(
        'Please enter Identifying number or EIN missing reason Or Reference ID number',
        'gtw-snackbar--red'
      );
      return;
    }

    if (
      this.line_2a_name ||
      this.line_2a_country_flag ||
      this.add_flag_2a ||
      this.add_flag_2a_f ||
      this.city_flag_2a ||
      this.state_flag_2a ||
      this.zip_flag_2a ||
      this.line_2c_name ||
      this.line_2c_country_flag ||
      this.add_flag_2c ||
      this.add_flag_2c_f ||
      this.city_flag_2c ||
      this.state_flag_2c ||
      this.zip_flag_2c ||
      this.line_2d_name ||
      this.line_2d_country_flag ||
      this.add_flag_2d ||
      this.add_flag_2d_f ||
      this.city_flag_2d ||
      this.state_flag_2d ||
      this.zip_flag_2d
    ) {
      this.gtwSnackbarService.openSnackBar('Please fill out required fields.', 'gtw-snackbar--red');
      return;
    }

    this.prepareAttribDataForSave();

    const scheduleSettings = [{
      tax_year: this.getCorrectTaxYear(),
      scenario: this.getCorrectScenario(),
      jcd_key: this.globalService?.jcd_key || 250
    }];

    const editRow: any[][] = [];

    for (let loopIndex = 1; loopIndex < this.irsF5471ScheduleNAData.length; loopIndex++) {
      const item = this.irsF5471ScheduleNAData[loopIndex];
      let attrValue = this.attribData[item.attrib_name];
      if (attrValue != null && typeof attrValue === 'number') attrValue = String(attrValue);

      const saveObject = [{
        tax_year: this.getCorrectTaxYear(),
        trans_type_key: item.trans_type_key,
        combination_key: this.rowData.HO_COMBINATION_KEY,
        group_obj_key: this.rowData.GROUP_OBJ_KEY,
        form_key: item.form_key,
        line_no: item.i?.line_no,
        occurence: item.occurrence === '0' ? null : item.occurrence,
        line_attrib_key: item.line_attrib_key,
        Attribute_Name: item.attrib_name,
        Attribute_Value: attrValue === '' ? '' : attrValue,
        trans_dtls_key: item.trans_details_key === '0' ? null : item.trans_details_key,
        trans_status: 'A',
        override_y_n: item.is_update === undefined ? 'N' : item.is_update
      }];
      editRow.push(saveObject);
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    this.crudLoading = true;

    this.form5471Service
      .saveForm5471ScheduleNA(
        this.getBaseUrl(),
        scheduleSettings,
        scheduleDetails,
        this.globalService,
        this.filterParams
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result: any) => {
          this.crudLoading = false;
          if (result.errorMessage && result.errorMessage !== 'null') {
            this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
          } else {
            this.gtwSnackbarService.openSnackBar('Textual Info details successfully saved', 'gtw-snackbar--green');
            this.loadFormData();
            this.requestGridUpdate.emit('refresh');
          }
          this.cdr.detectChanges();
        },
        (error: any) => {
          this.crudLoading = false;
          this.gtwSnackbarService.openSnackBar('Error saving Textual Info. Please try again.', 'gtw-snackbar--red');
        }
      );
  }

  private prepareAttribDataForSave() {
    const dateFields = ['5471_NA_CFC_BEGIN_DATE', '5471_NA_CFC_END_DATE', '5471_NA_1D'];
    dateFields.forEach(field => {
      if (this.attribData[field]) {
        const date = this.attribData[field];
        if (date instanceof Date) {
          this.attribData[field] = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
        }
      }
    });

    if (this.countryVar === 'US') {
      this.attribData['5471_NA_CFC_US_COUNTRY'] = this.countryVar;
      this.attribData['5471_NA_CFC_F_COUNTRY'] = null;
      this.attribData['5471_NA_CFC_F_ADDRESS_1'] = null;
      this.attribData['5471_NA_CFC_F_ADDRESS_2'] = null;
      this.attribData['5471_NA_CFC_F_CITY'] = null;
      this.attribData['5471_NA_CFC_F_STATE'] = null;
      this.attribData['5471_NA_CFC_F_ZIPCODE'] = null;
    } else if (this.countryVar) {
      this.attribData['5471_NA_CFC_F_COUNTRY'] = this.countryVar;
      this.attribData['5471_NA_CFC_US_COUNTRY'] = null;
      this.attribData['5471_NA_CFC_US_ADDRESS_1'] = null;
      this.attribData['5471_NA_CFC_US_ADDRESS_2'] = null;
      this.attribData['5471_NA_CFC_US_CITY'] = null;
      this.attribData['5471_NA_CFC_US_STATE'] = null;
      this.attribData['5471_NA_CFC_US_ZIPCODE'] = null;
    }

    if (this.countryCust === 'US') {
      this.attribData['5471_NA_PER_RECORDS_CUST_US_COUNTRY'] = this.countryCust;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_COUNTRY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_1'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ADDR_2'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_CITY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_STATE'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_F_ZIP'] = null;
    } else if (this.countryCust) {
      this.attribData['5471_NA_PER_RECORDS_CUST_F_COUNTRY'] = this.countryCust;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_COUNTRY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_1'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ADDR_2'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_CITY'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_STATE'] = null;
      this.attribData['5471_NA_PER_RECORDS_CUST_US_ZIP'] = null;
    }

    if (this.countryAgent === 'US') {
      this.attribData['5471_NA_BRANCH_US_COUNTRY'] = this.countryAgent;
      this.attribData['5471_NA_BRANCH_US_F_COUNTY'] = null;
      this.attribData['5471_NA_BRANCH_US_F_ADDR_1'] = null;
      this.attribData['5471_NA_BRANCH_US_F_ADDR_2'] = null;
      this.attribData['5471_NA_BRANCH_US_F_CITY'] = null;
      this.attribData['5471_NA_BRANCH_US_F_STATE'] = null;
      this.attribData['5471_NA_BRANCH_F_ZIP'] = null;
    } else if (this.countryAgent) {
      this.attribData['5471_NA_BRANCH_US_F_COUNTY'] = this.countryAgent;
      this.attribData['5471_NA_BRANCH_US_COUNTRY'] = null;
      this.attribData['5471_NA_BRANCH_US_ADDR_LINE_1'] = null;
      this.attribData['5471_NA_BRANCH_US_ADDR_LINE_2'] = null;
      this.attribData['5471_NA_BRANCH_US_CITY'] = null;
      this.attribData['5471_NA_BRANCH_US_STATE'] = null;
      this.attribData['5471_NA_BRANCH_US_ZIP'] = null;
    }

    if (this.countryCorporation === 'US') {
      this.attribData['5471_NA_FOREIGN_AGENT_US_COUNTRY'] = this.countryCorporation;
      this.attribData['5471_NA_FOREIGN_AGENT_F_COUNTRY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ADDR_1'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ADDR_2'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_CITY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_STATE'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_F_ZIP'] = null;
    } else if (this.countryCorporation) {
      this.attribData['5471_NA_FOREIGN_AGENT_F_COUNTRY'] = this.countryCorporation;
      this.attribData['5471_NA_FOREIGN_AGENT_US_COUNTRY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ADDR_1'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ADDR_2'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_CITY'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_STATE'] = null;
      this.attribData['5471_NA_FOREIGN_AGENT_ZIP'] = null;
    }

    if (this.filedOnBehalf) {
      this.attribData['5471_NA_PERSON_BEHALF'] = this.filedOnBehalf.LEGAL_ENTITY_ID;
    }

    if (this.selectedGroup) {
      if (this.selectedGroup.REG_ADDRESS_COUNTRY === 'US') {
        this.attribData['5471_NA_FILER_ADDRESS'] = this.selectedGroup.REG_ADDRESS_LINE1_5471;
        this.attribData['5471_NA_FILER_ADDRESS_LINE_2'] = this.selectedGroup.REG_ADDRESS_LINE2_5471;
        this.attribData['5471_NA_FILER_CITY'] = this.selectedGroup.REG_ADDRESS_CITY;
        this.attribData['5471_NA_FILER_STATE'] = this.selectedGroup.REG_ADDRESS_STATE;
        this.attribData['5471_NA_FILER_COUNTRY'] = this.selectedGroup.REG_ADDRESS_COUNTRY;
        this.attribData['5471_NA_FILER_ZIP'] = this.selectedGroup.REG_ADDRESS_ZIP;
        this.attribData['5471_NA_FILER_BEGIN_DATE'] = this.selectedGroup.FILER_TAX_YEAR_BEGIN;
        this.attribData['5471_NA_FILER_END_DATE'] = this.selectedGroup.FILER_TAX_YEAR_END;
        this.attribData['5471_NA_FILER_NAME'] = this.selectedGroup.LEGAL_ENTITY_NAME;
        this.attribData['5471_NA_FILER_LEGAL_ENTITY_ID'] = this.selectedGroup.LEGAL_ENTITY_ID;
        this.attribData['5471_NA_A'] = this.selectedGroup.FILER_EIN?.replace('-', '') || null;
        this.attribData['5471_NA_FILER_F_ADDR_LINE_1'] = null;
        this.attribData['5471_NA_FILER_F_ADDR_LINE_2'] = null;
        this.attribData['5471_NA_FILER_F_CITY'] = null;
        this.attribData['5471_NA_FILER_F_STATE'] = null;
        this.attribData['5471_NA_FILER_F_COUNTRY'] = null;
        this.attribData['5471_NA_FILER_F_ZIPCODE'] = null;
      } else {
        this.attribData['5471_NA_FILER_F_ADDR_LINE_1'] = this.selectedGroup.REG_ADDRESS_LINE1_5471;
        this.attribData['5471_NA_FILER_F_ADDR_LINE_2'] = this.selectedGroup.REG_ADDRESS_LINE2_5471;
        this.attribData['5471_NA_FILER_F_CITY'] = this.selectedGroup.REG_ADDRESS_CITY;
        this.attribData['5471_NA_FILER_F_STATE'] = this.selectedGroup.REG_ADDRESS_STATE;
        this.attribData['5471_NA_FILER_F_COUNTRY'] = this.selectedGroup.REG_ADDRESS_COUNTRY;
        this.attribData['5471_NA_FILER_F_ZIPCODE'] = this.selectedGroup.REG_ADDRESS_ZIP;
        this.attribData['5471_NA_FILER_BEGIN_DATE'] = this.selectedGroup.FILER_TAX_YEAR_BEGIN;
        this.attribData['5471_NA_FILER_END_DATE'] = this.selectedGroup.FILER_TAX_YEAR_END;
        this.attribData['5471_NA_FILER_NAME'] = this.selectedGroup.LEGAL_ENTITY_NAME;
        this.attribData['5471_NA_FILER_LEGAL_ENTITY_ID'] = this.selectedGroup.LEGAL_ENTITY_ID;
        this.attribData['5471_NA_A'] = this.selectedGroup.FILER_EIN?.replace('-', '') || null;
        this.attribData['5471_NA_FILER_ADDRESS'] = null;
        this.attribData['5471_NA_FILER_ADDRESS_LINE_2'] = null;
        this.attribData['5471_NA_FILER_CITY'] = null;
        this.attribData['5471_NA_FILER_STATE'] = null;
        this.attribData['5471_NA_FILER_COUNTRY'] = null;
        this.attribData['5471_NA_FILER_ZIP'] = null;
      }
    }

    if (this.selectedGroup1) {
      this.attribData['5471_NA_1G'] = this.selectedGroup1.ACTIVITY_DESC;
      this.attribData['5471_NA_1F'] = this.selectedGroup1.ACTIVITY_CODE;
    }

    this.attribData['5471_NA_D_Y'] = this.checkBoxd ? '1' : null;
    this.attribData['5471_NA_D_N'] = !this.checkBoxd ? '0' : null;
    this.attribData['5471_NA_ALT_INFO_2019_40_IND_Y'] = this.checkBoxf ? '1' : null;
    this.attribData['5471_NA_ALT_INFO_2019_40_IND_N'] = !this.checkBoxf ? '0' : null;
    this.attribData['5471_NA_B_1_Y'] = this.checkBoxb1 ? '1' : null;
    this.attribData['5471_NA_B_1_N'] = !this.checkBoxb1 ? '0' : null;
    this.attribData['5471_NA_B_3_Y'] = this.checkBoxb3 ? '1' : null;
    this.attribData['5471_NA_B_3_N'] = !this.checkBoxb3 ? '0' : null;
    this.attribData['5471_NA_B_4_Y'] = this.checkBoxb4 ? '1' : null;
    this.attribData['5471_NA_B_4_N'] = !this.checkBoxb4 ? '0' : null;
    this.attribData['5471_NA_B_5_Y'] = this.checkBoxb5 ? '1' : null;
    this.attribData['5471_NA_B_5_N'] = !this.checkBoxb5 ? '0' : null;
    this.attribData['5471_NA_B_1A_Y'] = this.checkBoxb1a ? '1' : null;
    this.attribData['5471_NA_B_1A_N'] = !this.checkBoxb1a ? '0' : null;
    this.attribData['5471_NA_B_1B_Y'] = this.checkBoxb1b ? '1' : null;
    this.attribData['5471_NA_B_1B_N'] = !this.checkBoxb1b ? '0' : null;
    this.attribData['5471_NA_B_1C_Y'] = this.checkBoxb1c ? '1' : null;
    this.attribData['5471_NA_B_1C_N'] = !this.checkBoxb1c ? '0' : null;
    this.attribData['5471_NA_B_5A_Y'] = this.checkBoxb5a ? '1' : null;
    this.attribData['5471_NA_B_5A_N'] = !this.checkBoxb5a ? '0' : null;
    this.attribData['5471_NA_B_5B_Y'] = this.checkBoxb5b ? '1' : null;
    this.attribData['5471_NA_B_5B_N'] = !this.checkBoxb5b ? '0' : null;
    this.attribData['5471_NA_B_5C_Y'] = this.checkBoxb5c ? '1' : null;
    this.attribData['5471_NA_B_5C_N'] = !this.checkBoxb5c ? '0' : null;
    this.attribData['5471_NA_FOB_SHAREHOLDER_Y'] = this.checkShareholder ? '1' : null;
    this.attribData['5471_NA_FOB_SHAREHOLDER_N'] = !this.checkShareholder ? '0' : null;
    this.attribData['5471_NA_FOB_OFFICER_Y'] = this.checkOfficer ? '1' : null;
    this.attribData['5471_NA_FOB_OFFICER_N'] = !this.checkOfficer ? '0' : null;
    this.attribData['5471_NA_FOB_DIRECTOR_Y'] = this.checkDirector ? '1' : null;
    this.attribData['5471_NA_FOB_DIRECTOR_N'] = !this.checkDirector ? '0' : null;
  }

  reset() {
    this.loadFormData();
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  formatDate(date: Date | string | null): string {
    if (!date) return '';
    const d = date instanceof Date ? date : parseAsLocalDate(date);
    if (!d || isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }

  formatDateForInput(date: Date | string | null | undefined): string {
    if (!date) return '';
    const dateObj = date instanceof Date ? date : parseAsLocalDate(date);
    if (!dateObj || isNaN(dateObj.getTime())) return '';
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onDateChange(value: string, attribName: string) {
    this.attribData[attribName] = parseAsLocalDate(value);
    this.setOverridesFlag(value, attribName);
    this.cdr.detectChanges();
  }

  isUSCountry(type: string): boolean {
    switch (type) {
      case 'var':
        return this.countryVar === 'US';
      case 'cust':
        return this.countryCust === 'US';
      case 'agent':
        return this.countryAgent === 'US';
      case 'corporation':
        return this.countryCorporation === 'US';
      default:
        return false;
    }
  }
}
